// provide a custom initializer for the translation service
import {TranslateService} from "@ngx-translate/core";

export interface ITranslatorManager
{
	initTranslator(ts: TranslateService): void;  // application provided initialization for translator

	switchLangHandler(ts: TranslateService, langId: string): void; // handler called when language need to change
}